<!--
 * @Author: lan.h
 * @Date: 2022-03-30 18:03:46
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-13 15:48:55
 * @Description: banner
-->
<template>
  <div class="banner" :class="live == 1 ? 'livebanner' : ''">
    <div class="banner-left">
      <swiper :options="swiper_option" ref="swiper" v-if="banner1.length">
        <div class="swiper-pagination" slot="pagination" key="swiper-pagination"></div>
        <swiper-slide v-for="item, index in banner1" :key="index" class="stop-swiping">
          <a class="banner-item" :href="item.link" target="_blank">
            <img :src="item.imgPath | logo_show" @click="addPuv(item.uid)" onclick="_czc.push(['_trackEvent', '首页(新)', '顶部轮播广告(左)', '点击量'])">
          </a>
        </swiper-slide>
      </swiper>
      <div class="prev-btn">
        <img :src="$store.state.static_img_url+'pic/vcbeat/left.png'">
      </div>
      <div class="next-btn">
        <img :src="$store.state.static_img_url+'pic/vcbeat/right.png'">
      </div>
    </div>
    <div class="banner-right">
      <a :href="banner4.link" target="_blank" onclick="_czc.push(['_trackEvent', '首页(新)', '顶部轮播广告(右上)', '点击量'])"><img :src="banner4.imgPath | logo_show"></a>
      <a :href="banner5.link" target="_blank" onclick="_czc.push(['_trackEvent', '首页(新)', '顶部轮播广告(右下)', '点击量'])"><img :src="banner5.imgPath | logo_show"></a>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: ['banner1', 'banner4', 'banner5', 'live'],
  computed: {
    swiper_option() {
      return {
        loop: true,
        autoplay: {
          delay: this.live == 1 ? 10000 : 5000,
          disableOnInteraction: false,
        },
        observer: true,
        navigation: {
          nextEl: '.next-btn',
          prevEl: '.prev-btn',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'custom',
          autoplayDisableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。默认为true：停止。
          renderCustom: (swiper, crt, total) => {
            var customPaginationHtml = ''
            for (var i = 0; i < total; i++) {
              //判断哪个分页器此刻应该被激活
              if (i == crt - 1) {
                customPaginationHtml +=
                  '<span class="swiper-pagination-bullet swiper-pagination-bullet-active"><a class="a"></a></span>'
              } else {
                customPaginationHtml += '<span class="swiper-pagination-bullet"></span>'
              }
            }
            return customPaginationHtml
          },
        },
      }
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
}
</script>
<style lang="stylus" scoped>
@keyframes progress
  0%
    width 0
  100%
    width 30px
.banner
  width 100%
  display flex
  justify-content space-between
  &.livebanner
    .banner-left
      >>>.swiper-container
        width 540px
        a
          width 540px
          height 340px
        .swiper-pagination
          .swiper-pagination-bullet-active
            .a
              animation progress 10s ease
    .banner-right
      width 260px
      height 340px
      a
        display block
        width 260px
        height 160px
  &-left
    position relative
    .prev-btn
      left 15px
    .next-btn
      right 15px
    .prev-btn, .next-btn
      position absolute
      top 50%
      z-index 2
      cursor pointer
      transform translateY(-50%)
      outline none
      img
        height 46px
        opacity 0.8
        &:hover
          transition all 0.5s
          opacity 1
    >>>.swiper-container
      width 530px
      a
        width 530px
        height 290px
        display block
        img
          width 100%
          height 100%
      .swiper-pagination
        bottom 16px
        right 0
        left auto
        width 100%
        text-align right
        position absolute
        z-index 2
        display flex
        justify-content center
        .swiper-pagination-bullet
          width 30px
          height 2px
          z-index 2
          margin-left 4px
          background rgba(153, 153, 153, 0.6)
          border-radius 0
          opacity 1
          a
            width 100%
            height 100%
        .swiper-pagination-bullet-active
          background rgba(153, 153, 153, 0.6)
          .a
            display block
            z-index 10
            background #FF8824
            opacity 1
            animation progress 5s ease
  &-right
    width 273px
    height 290px
    display flex
    flex-direction column
    justify-content space-between
    a
      display block
      width 273px
      height 137px
      img
        width 100%
        height 100%
  .banner-left, .banner-right
    a
      overflow hidden
      img
        transition all 0.5s
        -webkit-transition all 0.5s
        &:hover
          transform scale(1.04)
          transition all 0.6s ease 0s
</style>